import Cookies from 'js-cookie';
import axios from 'axios';

function csrfSafeMethod(method) {
  return (/^(GET|HEAD|OPTIONS|TRACE)$/i.test(method));
}


export function ajax(method, url, data, options = {}) {
  let headers = {
    'Accept': 'application/json',
    ...options.headers,
  };

  if (!csrfSafeMethod(method)) {
    let token = Cookies.get('csrftoken');
    console.log('token', token);
    headers['X-CSRFToken'] = token;
  }

  console.log(method, url, data);

  return axios({
    method: method,
    url: url,
    data,
    ...options,
    headers: headers,
  }).catch(function(error){
    console.log('error');
    if (error.response && error.response.data){
      let data = error.response.data;
      console.log('error data', data);

      if (data.error){
        return alert(data.error);
      }

      if (data.detail){
        return alert(data.detail);
      }

      if (data.non_field_errors){
        return alert(data.non_field_errors.join('\n'));
      }

      if (error.response.status === 400){
        let message = [];

        for(let key of Object.keys(data)){
          message.push(`${key}: ${data[key]}`)
        }

        return alert(message.join('\n'))
      }

      alert("Error " + error.response.status);

    } else if (error.response.status && error.response.status >= 400 && error.response.status < 600){
      alert("Error " + error.response.status);
    }

    throw error;
    // console.log(error.response.data);
  });
}

export function api(method, url, data, options) {
  return ajax(method, url, data, options).then(function (resp) {
    return resp.data;
  })
}


export function changeRequest(target, action, changes) {
  return api('POST', '/api/1/change-requests/', {
    target, action, changes: {...changes}
  })
}
